import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import P11Layout from "./P11Layout";
import { P11, fmtDate } from "./p11shared";
import { useP11Lang } from "./p11lang";

// Acht vaste sessies met eigen status + afmelden (>24u).
export default function P11Sessions() {
  const nav = useNavigate();
  const { lang, tt } = useP11Lang();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState("");

  const load = () => api.get("/project11/me/sessions").then(({ data }) => setData(data)).catch(() => nav("/project11/login"));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const cancel = async (s) => {
    setBusy(s.session_id);
    try {
      await api.post(`/project11/me/sessions/${s.session_id}/cancel`);
      toast.success(lang === "nl" ? "Afgemeld" : "Cancelled");
      load();
    } catch (err) {
      if (err?.response?.data?.detail === "WITHIN_24H") toast.error(tt("cancel_24h"));
      else toast.error(lang === "nl" ? "Afmelden mislukt" : "Cancellation failed");
    } finally { setBusy(""); }
  };

  if (!data) return <div className="p11-root min-h-screen flex items-center justify-center"><span className="p11-label">…</span></div>;
  const stateColor = { VERIFIED: P11.yellow, PENDING: P11.gray2, MISSED: "#6b6b6b", LOCKED: P11.gray };
  const stateLabel = { VERIFIED: tt("verified"), PENDING: tt("pending"), MISSED: tt("missed"), LOCKED: tt("locked") };

  return (
    <P11Layout>
      <div data-testid="p11-sessions">
        <div className="p11-label-yellow">{tt("my_sessions")}</div>
        <h1 className="p11-h1 text-3xl mt-4 mb-8">08 — {tt("sessions_l")}.</h1>
        <div className="divide-y" style={{ borderColor: P11.border }}>
          {data.sessions.map((s) => (
            <div key={s.session_id} className="py-5 flex flex-wrap items-center gap-4" data-testid={`p11-session-${s.number}`}>
              <span className="p11-mono text-2xl w-12" style={{ color: stateColor[s.state] }}>{String(s.number).padStart(2, "0")}</span>
              <div className="flex-1 min-w-40">
                <div className="text-sm" style={{ color: P11.text }}>{fmtDate(s.date, lang)}</div>
                <div className="p11-label mt-1">{s.start_time}–{s.end_time} · {s.location}</div>
              </div>
              <span className="p11-label" style={{ color: stateColor[s.state] }} data-testid={`p11-session-state-${s.number}`}>{stateLabel[s.state]}</span>
              {s.state === "LOCKED" && (
                <button onClick={() => cancel(s)} disabled={busy === s.session_id} className="p11-label px-3 py-1.5 border hover:text-white transition-colors" style={{ borderColor: P11.border, color: P11.gray }} data-testid={`p11-session-cancel-${s.number}`}>
                  {tt("cancel_session")}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </P11Layout>
  );
}
